import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmPopup from '../popups/ConfirmPopup';
import { createLogger } from '../../utils/logging';
import { joinClassNames } from '../../utils';

ConfirmButton.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onConfirm: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    tabIndex: PropTypes.number,
};

const logger = createLogger('ConfirmButton');

function ConfirmButton(props) {
    const {
        className = '',
        children,
        onConfirm,
        message,
        disabled = false,
        title = null,
        tabIndex = null,
    } = props;
    const [isPopupVisible, setPopupVisible] = useState(false);
    const onClickHandler = () => {
        logger.debug('Confirm button clicked.');
        setPopupVisible(true);
    };
    const onCancelHandler = () => {
        logger.debug('Confirm button - popup cancelled.');
        setPopupVisible(false);
    };
    const onConfirmCompleted = () => {
        logger.debug('Confirm button - popup confirmed.');
        setPopupVisible(false);
        onConfirm();
    };
    return (
        <>
            <button type="button" className={joinClassNames('confirm-button', className)} onClick={onClickHandler} disabled={disabled} title={title} aria-label={title} tabIndex={tabIndex}>{children}</button>
            {isPopupVisible && <ConfirmPopup onConfirm={onConfirmCompleted} onCancel={onCancelHandler} message={message} />}
        </>
    );
}

export default ConfirmButton;
